import React, { useEffect, useRef, forwardRef } from "react";
import styled from "styled-components";
import "mediaelement";
import hlsjs from "hls.js";
import "mediaelement/build/mediaelementplayer.min.css";

const VideoBox = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    aspect-ratio: 16 / 9;
    width: 80%;
    height: 100%;
    max-height: 90%;
    @media screen and (max-width: 720px) {
        width: 90%;
    }
    * div#videoMediaElement {
        width: 100% !important;
        height: 100% !important;
    }
    * iframe {
        width: 100% !important;
        height: 100% !important;
        margin-left: 0 !important;
        margin-right: 0 !important;
    }
`;

export const MediaElement = forwardRef((props, ref) => {
    const playerRef = useRef(null);

    const success = (media, node, instance) => {
        // Your action when media was successfully loaded
    };

    const error = (media) => {
        // Your action when media had an error loading
    };

    useEffect(() => {
        let loaded = false;
        if (!loaded && props.isYoutube) {
            const tag = document.createElement("script");
            tag.src = "//www.youtube.com/player_api";
            const firstScriptTag = document.getElementsByTagName("script")[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            loaded = true;
        }
    }, []);

    useEffect(() => {
        const { MediaElementPlayer } = global;

        if (!MediaElementPlayer) {
            return;
        }

        const options = {
            stretching: "fill",
            features: ["playpause", "current", "progress"],
            iconSprite: "/assets/mejs-controls.svg",
            success: (media, node, instance) => success(media, node, instance),
            error: (media, node) => error(media, node),
            youtube: {
                controls: 0,
            },
            setDimensions: true,
        };

        if (!window.Hls) window.Hls = hlsjs;
        playerRef.current = new MediaElementPlayer(props.id, options);

        return () => {
            if (playerRef.current) {
                try {
                    if (!playerRef.current.paused) {
                        playerRef.current.pause();
                    }
                    playerRef.current.remove();
                    playerRef.current = null;
                } catch (e) {}
            }
        };
    }, [props.id]);

    const sourceTags = props.sources.map((source) => `<source src="${source.src}" type="${source.type}">`).join("\n");

    const mediaBody = `${sourceTags}`;
    const mediaHtml = `<video 
            id="${props.id}"
            ${props.poster ? ` poster=${props.poster}` : ""}
            ${props.controls ? " controls" : ""}${props.preload ? ` preload="${props.preload}"` : ""}
        >
            ${mediaBody}
        </video>`;

    return <VideoBox dangerouslySetInnerHTML={{ __html: mediaHtml }}></VideoBox>;
});
